<script lang="ts" setup>import { toRef as _toRef } from 'vue';

import { useSharedData, usePage } from '@consumer/composables/sharedData'
import { useIsPdfCapture } from '@consumer/composables/pdfCapture'
import { cssPropertiesForTheme, setCurrentTheme } from '@consumer/composables/themes'

import V2Header from '@consumer/modules/v2/layout/Header.vue'
import V2Footer from '@consumer/modules/v2/layout/Footer.vue'
import BaseLayout from '@consumer/layouts/BaseLayout.vue'
import { useScreen } from '@consumer/helpers/screen'

defineOptions({
  inheritAttrs: false,
})

useScreen()

const __$temp_1 = (useSharedData()),
  currentUser = _toRef(__$temp_1, 'currentUser'),
  currentTheme = _toRef(__$temp_1, 'currentTheme');

const __$temp_2 = (usePage()),
  component = _toRef(__$temp_2, 'component'),
  url = _toRef(__$temp_2, 'url');
const isPdfCapture = useIsPdfCapture()

const theme = setCurrentTheme()

const headerType = computed(() => {
  if ([
    'MultiPlaceGiftIdea',
    'CheckoutOrderConfirmation',
    'CheckoutCart',
    'CalendarEvent',
  ].includes(component.value)
    || url.value.startsWith('/u/')
    || url.value.startsWith('/my-account')
    || url.value.startsWith('/login')
    || url.value.startsWith('/signup')
  ) {
    return 'product'
  }
  else if (component.value === 'Checkout') {
    return 'checkout'
  }
  else if (
    [
      'RecipientGiftCardAccess',
      'RecipientGiftCardActivate',
      'RecipientGiftCardBlocked',
      'RecipientGiftCardManage',
      'RecipientGiftLandingV2',
      'ResendUnlockInstructions',
      'UnlockAccount',
      'Unsubscribe',
      'ContactOptOut',
    ].includes(component.value)
    || url.value.startsWith('/support')
    || url.value.startsWith('/entercode')
    || url.value.startsWith('/card/activate')
    || url.value.startsWith('/calendar/invitations')
  ) {
    return 'simple'
  }
  else {
    return 'default'
  }
})

const footerType = computed(() => {
  if (component.value === 'RecipientGiftLandingV2') {
    return false
  }
  else if (
    component.value.startsWith('Checkout')
  ) {
    return 'checkout'
  }
  else if (url.value.startsWith('/card/manage') || url.value.startsWith('/card/access')) {
    return 'card_manage'
  }
  else if (
    url.value.startsWith('/support')
    || url.value.startsWith('/entercode')
    || url.value.startsWith('/card/activate')
    || component.value === 'Unsubscribe'
    || component.value === 'ContactOptOut'
  ) {
    return 'simple'
  }
  else {
    return 'default'
  }
})

</script>

<template>
  <Head>
    <title>Giftly: Online gift cards, printable gift cards, email gift cards, e-gift cards</title>
  </Head>

  <BaseLayout
    :key="`${headerType}-${Boolean(currentUser)}-${currentTheme}`"
    :style="cssPropertiesForTheme(theme)"
  >
    <slot name="header">
      <V2Header
        :type="isPdfCapture ? 'simple' : headerType"
        :currentUser="currentUser"
        :currentTheme="currentTheme"
      />
    </slot>

    <div
      class="w-full relative flex-1 flex flex-col"
      data-qa="PageContent"
    >
      <slot/>
    </div>

    <V2Footer
      v-if="footerType"
      :type="footerType"
    />
  </BaseLayout>
</template>
